import { navigation } from '../app/navigation.js';
import { HTMLControl } from '../controls/html_control.js';
import { window } from '../window.js';

class LocationControl extends HTMLControl {
  constructor() {
    super();

    this.readonly = false;

    this._placeInfo = { id: null };
    this._onchange = null;
  }

  initialize() {
    super.initialize();

    this.classList.add('editable-control-container');

    this.imageElement.onclick = () => this.showMap();
    this.valueElement.onclick = () => this.showMap();

    let controlEl = this.editableControlElement;
    controlEl.onkeypress = ev => {
      if (ev.key == ' ') {
        this.showMap();
      }
    };
    controlEl.onfocus = () => controlEl.setAttribute('hasfocus', 'true');
    controlEl.onblur = () => {
      controlEl.removeAttribute('hasfocus');
    };
  }

  static properties = {
    label: {
      attribute: true,
      set(v) {
        this.labelElement.innerHTML = `${v}:&nbsp;`;
      },
    },
  };

  static markup = `
<span class='editable-loc-control editable-control' tabindex='0'>
  <span class='editable-control-label'></span>
  <span class='editable-control-loc-value'></span>
  <img class='hvr-grow' src='/images/location.png'>
</span>
`;

  setLocationTo(loc) {
    if (this.readonly) {
      return;
    }
    this.value = loc;
    if (this._onchange) {
      this._onchange();
    }
    if (this.validate()) {
      this.editableControlElement.focus();
    }
  }

  get value() {
    return this._placeInfo;
  }
  set value(v) {
    this._placeInfo = v;
    if (this._placeInfo) {
      this.valueElement.textContent = this._placeInfo.name;
    }
  }

  get lat() {
    return this._placeInfo && parseFloat(this._placeInfo.lat);
  }
  get lng() {
    return this._placeInfo && parseFloat(this._placeInfo.lng);
  }

  get plainStyle() {
    return this.hasAttribute('plain');
  }
  set plainStyle(v) {
    if (v) {
      this.setAttribute('plain', 'true');
      this.editableControlElement.setAttribute('tabindex', 0);
    } else {
      this.removeAttribute('plain', 'true');
      this.editableControlElement.setAttribute('tabindex', -1);
    }
  }

  get onchange() {
    return this._onchange;
  }
  set onchange(v) {
    this._onchange = v;
  }

  get consumerId() {
    return `location-control:${this.id}`;
  }

  showMap() {
    const options = {
      consumerId: this.consumerId,
      locId: this._placeInfo.id,
      hostPanel: 'trip',
    };
    navigation.openMap(options);
  }

  checkValidity() {
    return this._placeInfo && this._placeInfo.name;
  }
  validate() {
    let el = this.editableControlElement;
    if (this.checkValidity()) {
      el.removeAttribute('invalid');
      return true;
    }

    el.setAttribute('invalid', 'true');
    el.focus();
    return false;
  }

  static selectors = {
    EditableControl: '.editable-control',
    Image: 'img',
    Label: '.editable-control-label',
    Value: '.editable-control-loc-value',
  };

  static elements = {
    editableControlElement: this.selectors.EditableControl,
    labelElement: this.selectors.Label,
    imageElement: this.selectors.Image,
    valueElement: this.selectors.Value,
  };
}

window.customElements.define('location-control', LocationControl);

export { LocationControl };
